import LabelT from '@components/tailwind-components/Label/LabelT';
import type React from 'react';
import { Controller } from 'react-hook-form';
import type { IScheduleProps } from '../../../interfaces/IInputProps';

export const CronInput: React.FC<IScheduleProps> = ({
  name,
  control,
  watch,
  label,
}) => {
  const delimiter = ' ';

  return (
    <div className='relative before-content' data-before={delimiter}>
      <div className='mt-1'>
        <LabelT text={label} />
        <div className='flex mt-1'>
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange } }) => {
              const value: string = watch(name);

              // * Ensure the input is cron time compatible (was setup before)
              const cronTabs =
                value.includes(delimiter) && value.split(delimiter).length === 5
                  ? value.split(delimiter)
                  : // * if not we want to zero out the cron input
                    ['', '', '', '', ''];

              return (
                <>
                  {cronTabs.map((cronTab, index) => {
                    return (
                      <input
                        key={`exportTime.${index}`}
                        id={`exportTime.${index}`}
                        type='string'
                        className='flex-none w-[60px] h-[35px] py-1.5 px-2.5 border border-gray-200 text-sm leading-5 font-normal outline-none focus:border-primary-base focus:outline-none focus:shadow-none first:border-r-0 rounded-tl-md rounded-bl-md'
                        value={cronTab}
                        onChange={(val) => {
                          const newCronTabs = [...cronTabs];
                          newCronTabs[index] = val.target.value;
                          return onChange(newCronTabs.join(' '));
                        }}
                      />
                    );
                  })}
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CronInput;
